import { FileUpload } from "./fileUpload";
import { FormatDate } from "./formatDate";
import ConfirmationMessage from "@/Components/ConfirmationMessage";

export const Ticket = {
    mixins: [FormatDate, FileUpload],
    props: {
        hideTicketSeverity: Boolean,
        ticketPriority: Array,
        allTicketStatus: Array,
        ticketCategory: Array,
        defaultTicketCategory: String,
        ticketAttributesOnDetail: Array,
        helpDeskUser: String,
        userMainAccountName: String,
        useUserEmail: Boolean,
        userSubAccountName: String,
        view: String,
        fileUploadSize: Number,
        userEmail: String,
        userId: String,
        ticketReferenceIsEnabled: Boolean
    },
    components: {
        ConfirmationMessage,
    },
    data() {
        return {
            usercomment: "",
            form: this.$inertia.form({
                fileupload: null,
                entityId: "",
                comment: "",
                userEmail: "",
                fileName: "",
                fileType: "",
                userID: "",
                view: this.view,
            }),
            commentCreationStatus: "",
            isAlertShown: false,
            isImgvalid: true,
            isUserImgvalid: true,
            file: "",
        };
    },
    methods: {
        getStarRating(i, ticketRating) {
            const rating = ticketRating.split("_")[1];
            return i <= rating ? "text-yellow-500" : "text-black";
        },
        ticketName(value) {
            return this.ticketPriority.find((x) => x.id === value.toString())[
                "name"
            ];
        },
        ticketStatusName(value) {
            return this.allTicketStatus.find((x) => x.id === value.toString())[
                "name"
            ];
        },
        ticketCategoryName(value) {
            if (value == this.defaultTicketCategory) {
                return "-";
            } else {
                return this.ticketCategory.find(
                    (x) => x.id === value.toString()
                )["name"];
            }
        },
        getAttributeValue(id, attribute, ticketAttribute) {
            const arrayWithFilterObjects = ticketAttribute.filter(
                (o) => o.attributeDefinitionId === id
            );

            if (arrayWithFilterObjects[0]["booleanValue"]) {
                return String(arrayWithFilterObjects[0]["booleanValue"]);
            }
            if (arrayWithFilterObjects[0]["numberValue"]) {
                return arrayWithFilterObjects[0]["numberValue"];
            }
            if (arrayWithFilterObjects[0]["dateValue"]) {
                return this.formatDate(arrayWithFilterObjects[0]["dateValue"]);
            }
            if (arrayWithFilterObjects[0]["stringValue"]) {
                return arrayWithFilterObjects[0]["stringValue"];
            }
            if (arrayWithFilterObjects[0]["selectedValueId"]) {
                const selectedValue = attribute.filter(
                    (a) => a.id === arrayWithFilterObjects[0]["selectedValueId"]
                );
                return selectedValue[0]["value"];
            }
            if (
                arrayWithFilterObjects[0]["selectedValues"] &&
                arrayWithFilterObjects[0]["selectedValues"].length > 0
            ) {
                let values = [];
                arrayWithFilterObjects[0]["selectedValues"].forEach(
                    (element) => {
                        const selectedValue = attribute.filter(
                            (a) => a.id === element.id
                        );
                        values.push(selectedValue[0]["value"]);
                    }
                );
                return values.join(", ");
            }
        },
        imageLoadError(event) {
            event.target.src = "/img/avatar.png";
        },
    },
};
